export const USER_PROFILE_VUEX_NAMESPACE = "autoaUserProfile";
